// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2u5il","containerItemsCenter":"Skeleton_containerItemsCenter__JPqgl"};